export enum APP_USER_ACTIVITY_TYPE {
  ASK_FOR_REVIEW_CLICK_FIVE_STARS = 0,
  ASK_FOR_REVIEW_CLICK_REPORT_PROBLEM = 1,
  ASK_FOR_REVIEW_CLICK_LATER = 2,
  // PROMO_BAR_CLOSE = 3,
}
